import { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import {
  Container,
  Typography,
  Box,
  CircularProgress,
  Grid,
  Button,
} from "@mui/material";

import DashboardLayout from "../../../../layouts/DashboardLayout";
import CeroTable from "../../../../components/CeroTable";
import CeroButton from "../../../../components/CeroButton";
import { STATUS } from "../../../../redux/constants";

import useStyles from "./styles";
import CeroSelect from "../../../../components/CeroSelect";
import ArrowBackIosIcon from "@mui/icons-material/ArrowBackIos";
import {
  getProductionDataList,
  superAdminSubscriptionAttachments,
  superAdminSubscriptionLogs,
} from "../../../../redux/actions";
import { months, sampleYear } from "../../../../constants";
import CeroPopUp from "../../../../components/CeroPopUp";
import PdfFileIconWithDownload from "../../../../assets/images/Download";
import CloseIcon from "@mui/icons-material/Close";
import IconButton from "@mui/material/IconButton";
import VisibilityIcon from "@mui/icons-material/Visibility";
import DownloadIcon from "@mui/icons-material/Download";
import PictureAsPdfIcon from "@mui/icons-material/PictureAsPdf";
import ImageIcon from "@mui/icons-material/Image";
import { useSnackbar } from "notistack";
import CustomModal from "./CustomModal";

export const SubscriptionListColumns = [
  {
    columnKey: "date",
    columnId: "date",
    columnHeader: "Date & Time",
  },
  {
    columnKey: "action",
    columnId: "action",
    columnHeader: "Action Type",
  },
  {
    columnKey: "start_date",
    columnId: "start_date",
    columnHeader: "Start Date",
  },
  {
    columnKey: "end_date",
    columnId: "end_date",
    columnHeader: "End Date",
  },
  {
    columnKey: "note",
    columnId: "note",
    columnHeader: "Notes",
  },
  {
    columnKey: "attachements",
    columnId: "attachements",
    columnHeader: "Attachements",
  },
];
const monthNames = [
  "JAN",
  "FEB",
  "MAR",
  "APR",
  "MAY",
  "JUN",
  "JUL",
  "AUG",
  "SEP",
  "OCT",
  "NOV",
  "DEC",
];

// const subscriptionDataList = [
//   {
//     date: "18-06-2025",
//     action_type: "Extend subscription",
//     start_date: "20-06-2025",
//     end_date: "19-06-2026",
//     notes: "Nothing",
//     attachements: [
//       "https://morth.nic.in/sites/default/files/dd12-13_0.pdf",
//       "https://fastly.picsum.photos/id/383/200/300.jpg?hmac=sP8wzjNbIJGIPQg-3A86o43HsTopJPnwV73iSCwH9cw",
//     ],
//   },
// ];

const SubscriptionDataList = () => {
  const classes = useStyles();
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { companyId } = useParams();
  const [isSubscriptionPopupOpen, setIsSubscriptionPopupOpen] = useState(null);
  const [isModalOpen, setIsModalOpen] = useState(null);
  const [header, setHeader] = useState(null);

  const [selectedFiles, setSelectedFiles] = useState([]);
  const [previewFiles, setPreviewFiles] = useState([]);
  const [choosenYear, setChooseYear] = useState();
  const productionListStatus = STATUS.SUCCESS;

  const subscriptionDataList = useSelector(
    (state) => state.superAdmin.superAdminSubscriptionLogs.data
  );
  const subscriptionAttachments = useSelector(
    (state) => state.superAdmin.superAdminSubscriptionAttachments.data
  );
  const subscriptionAttachmentsStatus = useSelector(
    (state) => state.superAdmin.superAdminSubscriptionAttachments.status
  );

  //   const getDate = (month, year) => {
  //     const selectedMonth = months?.filter((item) => item.key === month);
  //     return `${selectedMonth[0]?.value?.slice(0, 3)}/${year}`;
  //   };

  function formatTimestamp(timestamp) {
    const date = new Date(timestamp);

    const day = String(date.getDate()).padStart(2, "0");
    const monthNames = [
      "JAN",
      "FEB",
      "MAR",
      "APR",
      "MAY",
      "JUN",
      "JUL",
      "AUG",
      "SEP",
      "OCT",
      "NOV",
      "DEC",
    ];
    const month = monthNames[date.getMonth()];
    const year = date.getFullYear();

    let hours = date.getHours();
    const minutes = String(date.getMinutes()).padStart(2, "0");
    const ampm = hours >= 12 ? "PM" : "AM";
    hours = hours % 12 || 12;

    return `${day}-${month}-${year} ${hours}:${minutes}${ampm}`;
  }

  const handleDownload = (file) => {
    if (!file) return;
    window.open(file, "_blank", "noopener,noreferrer");
  };
  const handleDownloadAll = (files) => {
    if (!files || !files.length) return;

    files.forEach((file, index) => {
      if (file) {
        setTimeout(() => {
          window.open(file.url, "_blank", "noopener,noreferrer");
        }, index * 500); // Delay 500ms between each
      }
    });
  };

  const subscriptionstData = () =>
    Array.isArray(subscriptionDataList)
      ? subscriptionDataList &&
        subscriptionDataList?.map((item) => ({
          ...item,
          date: formatTimestamp(item.created_ts),
          attachements: (
            <a
              className={classes.linkText}
              onClick={() => {
                dispatch(superAdminSubscriptionAttachments(companyId, item.id));
                setIsSubscriptionPopupOpen(true);
                setHeader(
                  `Attachment For: ${item?.action} ( ${formatTimestamp(
                    item?.created_ts
                  )} )`
                );
              }}
            >
              View
            </a>
          ),
        }))
      : [];

  useEffect(() => {
    setSelectedFiles(subscriptionAttachments);
  }, [dispatch, subscriptionAttachments, subscriptionAttachmentsStatus]);

  useEffect(() => {
    dispatch(superAdminSubscriptionLogs(companyId));
  }, [dispatch, choosenYear]);

  const getExtendSubPopup = () => {
    return (
      <Box className={classes.popUp}>
        <CloseIcon onClick={handleClosePopup} className={classes.closeIcon} />
        <div className={classes.linkDiv}>
          <Typography
            className={classes.linkText}
            onClick={() => {
              setPreviewFiles(selectedFiles);
              setIsModalOpen(true);
            }}
          >
            Preview
          </Typography>
          <Typography
            className={classes.linkText}
            onClick={() => handleDownloadAll(selectedFiles)}
          >
            Download all
          </Typography>
        </div>

        <div className={classes.fileDiv}>
          <Box sx={{ display: "flex", gap: "12px", flexWrap: "wrap" }}>
            {selectedFiles?.map((file, index) => {
              const isPdf = file.file_name.toLowerCase().endsWith(".pdf");

              return (
                <div style={{ textAlign: "center" }}>
                  <Box
                    key={index}
                    sx={{
                      position: "relative",
                      width: 120,
                      height: 120,
                      border: "1px solid #ccc",
                      borderRadius: "6px",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      "&:hover .actions": {
                        opacity: 1,
                      },
                    }}
                  >
                    {isPdf ? (
                      <>
                        <PictureAsPdfIcon fontSize="large" color="error" />
                      </>
                    ) : (
                      <>
                        <ImageIcon fontSize="large" color="primary" />
                      </>
                    )}

                    {/* Action Buttons */}
                    <Box
                      className="actions"
                      sx={{
                        position: "absolute",
                        top: 0,
                        left: 0,
                        width: "100%",
                        height: "100%",
                        bgcolor: "rgba(0,0,0,0.6)",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        gap: "8px",
                        opacity: 0,
                        transition: "opacity 0.3s",
                        borderRadius: "6px",
                      }}
                    >
                      <IconButton
                        sx={{ color: "#fff" }}
                        onClick={() => {
                          setPreviewFiles([file]);
                          setIsModalOpen(true);
                        }}
                      >
                        <VisibilityIcon />
                      </IconButton>
                      <IconButton
                        onClick={() => {
                          handleDownload(file.url);
                        }}
                        sx={{ color: "#fff" }}
                      >
                        <DownloadIcon />
                      </IconButton>
                    </Box>
                  </Box>
                  <Typography>{file.file_name}</Typography>
                </div>
              );
            })}
          </Box>
        </div>
        <div className={classes.extendButtonContainer}>
          <CeroButton
            className={classes.buttonSecondary}
            variant="outlined"
            onClick={() => setIsSubscriptionPopupOpen(false)}
            buttonText="Close"
          />
        </div>
      </Box>
    );
  };

  const handleClosePopup = () => {
    setIsSubscriptionPopupOpen(false);
  };
  const closeModal = () => {
    setIsModalOpen(false);
  };
  // const handleDownload = (fileUrl) => {
  //   try {
  //     const url = fileUrl;
  //     const link = document.createElement("a");
  //     link.href = url;
  //     link.click();
  //   } catch (error) {
  //     enqueueSnackbar(error?.message, { variant: "error" });
  //   }
  // };
  return (
    <DashboardLayout>
      <Container className={classes.container}>
        <div className={classes.backContainer}>
          <div
            className={classes.backButtonDiv}
            onClick={() => {
              navigate(-1);
            }}
          >
            <ArrowBackIosIcon />
            Back
          </div>
        </div>

        {true ? (
          <Container className={classes.tableContainer}>
            <CeroTable
              columns={SubscriptionListColumns}
              hasMore={false}
              loading={false}
              data={subscriptionstData}
              onSelectRow={() => console.log("")}
            />
          </Container>
        ) : (
          <Box className={classes.loader}>
            <Typography variant="h7" component="span">
              {productionListStatus === STATUS.RUNNING ? (
                <CircularProgress />
              ) : productionListStatus === STATUS.ERROR ? (
                "We couldn't process your request. Please try again later"
              ) : (
                ""
              )}
            </Typography>
          </Box>
        )}
      </Container>
      <CeroPopUp
        primaryPopUp={{
          open: isSubscriptionPopupOpen,
          onClose: { handleClosePopup },
          content: getExtendSubPopup(),
          header: {
            title: header,
          },
        }}
        classes={{ dialog: classes.subDialog, headerTitle: classes.popUpTitle }}
      />
      <CustomModal
        isOpen={isModalOpen}
        onClose={closeModal}
        files={previewFiles}
        title={"Attachment"}
      />
    </DashboardLayout>
  );
};

export default SubscriptionDataList;
